<div class="ui-nav-section" (click)="toggled.emit()">
  <span class="ui-nav-section__label">{{ label }}</span>
  <ui-icon
    class="ui-nav-section__chevron"
    [class.ui-nav-section__chevron--expanded]="!collapsed"
    name="ChevronDown"
    size="small">
  </ui-icon>
</div>
